// Keep drawer open and open submenu when "Shop By" (href="#") is tapped
document.addEventListener('click', function (e) {
  // capture clicks early so theme's drawer-closer can't run first
  const link = e.target.closest('a.mobile-nav__link[href="#"]');
  if (!link) return;

  // Only act if this link is the top-level "Shop By" item
  const topItem = link.closest('li.mobile-nav__item.top-level');
  if (!topItem) return;

  const wrapper = link.closest('.mobile-nav__has-sublist');
  const toggle = wrapper ? wrapper.querySelector('.mobile-nav__toggle button') : null;

  if (toggle) {
    // prevent navigation + stop theme’s drawer-close listeners
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // fire the theme’s own toggle so all animations/classes are correct
    toggle.click();
  }
}, true); // <-- use capture phase so we win the race
